<template>
  <div class="login-body bg-F3F4F9">
    <div class="auth-navigationbar bg-282B80 cursor">
      <!-- <img src="../../../../assets/icon-lib-logo-bg.png" class="cursor" @click="toHome"> -->
      <img :src="clients.logoMain" alt="">
    </div>
    <div class="auth-body flex-center">
      <div class="auth-body-view bg-white">
        <div class="auth-body-view-menu flex-center">
          <div class="cursor">
            <p class="font-size-20 font-color-264480 font-bold">绑定手机号</p>
          </div>
        </div>

        <!-- 个人登录 -->
        <div>
          <!-- 手机号短信验证码表单 -->
          <div class="auth-body-view-menu-form">
            <div class="auth-body-view-menu-form-item" :class="personphoneerror?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-login-phone.png" alt="">
                <el-input v-model="personphone" placeholder="请输入您的手机号" size="normal" :maxlength="11" @blur="inputPhone" />
              </div>
            </div>

            <!-- 输入手机号规则校验错误提示 -->
            <div v-if="personphoneerror" class="auth-body-view-menu-form-ruleerror">
              <div class="flex-row-align-center ">
                <p class="font-size-12 font-color-CD2E2E">请输入正确手机号</p>
              </div>
            </div>

            <div class="auth-body-view-menu-form-item" :class="personcodeerror?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-login-phonecode.png" alt="">
                <el-input v-model="personcode" placeholder="请输入短信验证码" size="normal" :maxlength="6" @blur="inputCode" />
                <div class="auth-body-view-menu-form-item-option-codebtn flex-center bg-282B80 cursor" :class="personcodebtntext!='获取短信验证码'&&personcodebtntext!='重新获取验证码'?'auth-body-view-menu-form-item-option-codebtnopacity':''" @click="verifyapply">
                  <p class="font-color-white font-size-12">{{ personcodebtntext }}</p>
                </div>
              </div>
            </div>
            <!-- 输入验证码规则校验错误提示 -->
            <div v-if="personcodeerror" class="auth-body-view-menu-form-ruleerror">
              <div class="flex-row-align-center ">
                <p class="font-size-12 font-color-CD2E2E">请输入验证码</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 登录按钮 -->
        <div class="auth-body-view-login">
          <div class="auth-body-view-login-btn bg-282B80 flex-center cursor" @click="requestLogin">
            <p class="font-color-white font-size-14 font-bold">绑定</p>
          </div>
        </div>

      </div>
    </div>
    <verify ref="verify" :mode="'pop'" :captcha-type="'blockPuzzle'" :img-size="{ width: '330px', height: '155px' }" @success="verifySuccess" />
  </div>
</template>

<script>
import api from '../../../..//api/auth.js'
import user from '../../../..//models/user.js'
import verify from '@/components/verifition/Verify.vue'

export default {
  name: 'Bind',
  components: {
    verify
  },
  data() {
    return {

      redirectUrl: '',
      openId: '',
      accessToken: '',

      personphone: '',
      personcode: '',
      persontimer: null,
      persontimeremain: 60,
      personcodebtntext: '获取短信验证码',
      personphoneerror: false,
      personcodeerror: false,

      showError: false,
      clients: ''
    }
  },
  created() {
    this.redirectUrl = this.$route.query.r || '/'
    this.accessToken = this.$route.query.access
    this.openId = this.$route.query.open

    let that = this;
    this.$store.dispatch('navigation/setNavigatorIndex', 0)
    setTimeout(() => {
      that.clients = that.$store.getters.application  
    }, 1200);
  },
  methods: {
    getPhoneCode(code) {
      if (this.personcodebtntext !== '获取短信验证码' && this.personcodebtntext !== '重新获取验证码') {
        return
      }
      if (!(/^1[3456789]\d{9}$/.test(this.personphone))) {
        console.error(`填写正确的手机号${this.personphone}`)
        return
      }
      const params = {
        phone: this.personphone,
        captchaVerification: code,
        clientUid: localStorage.getItem('slider')
      }
      const that = this
      api.sliderCheck(params).then(r => {
        that.timeRemain()
      }).catch(err => {
        that.$message({
          showClose: false,
          message: err.message,
          type: 'error'
        })
      })
    },
    timeRemain() {
      if (!this.persontimer) {
        const that = this
        const timer = setInterval(() => {
          that.persontimeremain = that.persontimeremain - 1
          if (that.persontimeremain === 0) {
            that.persontimeremain = 60
            clearInterval(timer)
            that.persontimer = null
            that.personcodebtntext = '重新获取验证码'
          } else {
            that.personcodebtntext = `${that.persontimeremain}s后重新获取`
          }
        }, 1000)
        this.persontimer = timer
      }
    },
    inputPhone() {
      this.personphoneerror = !(/^1[3456789]\d{9}$/.test(this.personphone))
    },
    inputCode() {
      if (!this.personcode || this.personcode === '') {
        this.personcodeerror = true
      } else {
        this.personcodeerror = false
      }
    },
    verifyapply() {
      if (this.personphoneerror || this.personphone === '') {
        return
      }
      if (this.personcodebtntext === '获取短信验证码' || this.personcodebtntext === '重新获取验证码') {
        this.$refs.verify.show()
      }
    },
    verifySuccess(params) {
      this.getPhoneCode(params.captchaVerification)
    },
    requestLogin() {
      if (this.showError) {
        return
      }
      if (!this.personphone || this.personphone === '' || !(/^1[3456789]\d{9}$/.test(this.personphone))) {
        this.$message({
          showClose: false,
          message: '请输入正确手机号',
          type: 'error'
        })
        return
      }
      if (!this.personcode || this.personcode === '') {
        this.$message({
          showClose: false,
          message: '请输入验证码',
          type: 'error'
        })
        return
      }
      const params = {
        code: this.personcode,
        phone: this.personphone,
        userType: 1,
        tenantId: this.$store.getters.tenantId,
        openid: this.openId,
        access_token: this.accessToken
      }
      const that = this
      api.loginWithPhoneCode(params).then(r => {
        that.$store.dispatch('user/setToken', r.data.authInfo)
        user.updateUser()
        if (parseInt(r.data.userInfo.authentication)) {
          that.$router.push({
            path: that.redirectUrl
          })
        } else {
          that.$router.push({
            name: 'Auth',
            query: {
              r: that.redirectUrl
            }
          })
        }
      }).catch(err => {
        that.showError = true
        that.errorCounter()
        that.$message({
          showClose: false,
          message: err.message,
          type: 'error'
        })
      })
    },
    toHome() {
      this.$store.dispatch('navigation/setNavigatorIndex', 0)
      this.$router.push({
        path: '/'
      })
    },
    errorCounter() {
      const that = this
      setTimeout(() => {
        that.showError = false
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  font-size: 12px !important;
  color: #264480 !important;
  padding: 0 !important;
  border: none !important;
  background: initial;
}

::v-deep .el-input__suffix-inner {
  display: none;
}

::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-input__prefix {
  left: 0;
  display: none;
}

::v-deep .el-input__icon {
  width: initial !important;
}

::v-deep .el-input {
  width: initial;
  flex: 1;
}

/deep/ .el-select-dropdown__item.selected {
  color: #264480 !important;
}
</style>

<style src="@/styles/pc.css" scoped>
</style><style scoped>
.login-body {
  flex: 1;
}
.auth-navigationbar {
  width: 100%;
  height: 70px;
}
.auth-navigationbar img {
  width: 100%;
  height: 100%;
}

.auth-body {
  width: 1240px;
  height: 510px;
  margin: 0 auto;
  background-color: #F3F4F9;
}

.auth-body-view {
  width: 600px;
  padding-top: 30px;
  padding-bottom: 40px;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05);
}

.auth-body-view-menu {
  height: 54px;
  width: 100%;
}

.auth-body-view-menu-line {
  width: 1px;
  height: 20px;
  background-color: #F3F4F9;
  margin: 0 26px;
}

.opacity {
  opacity: 0.7;
}

.auth-body-view-menu-form {
  margin-top: 20px;
}

.auth-body-view-menu-form-item {
  height: 40px;
  padding: 0 130px;
  margin-bottom: 24px;
}

.auth-body-view-menu-form-item-inputerror {
  margin-bottom: 0;
}

.auth-body-view-menu-form-item input {
  border: none;
  width: 100%;
  height: 40px;
  background-color: rgba(0, 0, 0, 0);
}

.auth-body-view-menu-form-item input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #7B84A1;
}

.auth-body-view-menu-form-item input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #7B84A1;
}

.auth-body-view-menu-form-item input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #7B84A1;
}

.auth-body-view-menu-form-item input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #7B84A1;
}

.auth-body-view-menu-form-item input:focus {
  outline: none;
}

.auth-body-view-menu-form-item-option {
  border: 1px solid #DEE0E7;
  height: 40px;
  width: 100%;
  padding: 0 8px;
  background: #F9F9FC;
}

.auth-body-view-menu-form-ruleerror {
  height: 40px;
  width: 100%;
  padding: 0 130px;
  margin-bottom: 8px;
}

.auth-body-view-menu-form-ruleerror>div {
  height: 40px;
}

.auth-body-view-menu-form-item-inputerror .auth-body-view-menu-form-item-option {
  border: 1px solid #CD2E2E;
  height: 40px;
  width: 100%;
  padding: 0 8px;
  background: #FFEFEF;
}

.auth-body-view-menu-form-item-option-codebtn {
  width: 100px;
  height: 24px;
}

.auth-body-view-menu-form-item-option-codebtnopacity {
  opacity: 0.5;
}

.auth-body-view-login {
  padding: 22px 130px 0;
}

.auth-body-view-login-btn {
  height: 40px;
}

.auth-body-view-wechat {
  padding: 10px 130px 0;
}

.auth-body-view-wechat-btn {
  height: 40px;
}

.auth-body-view-login-btn {
  height: 40px;
}

.auth-body-view-protocal {
  padding: 26px 0 0;
}

.auth-body-view-protocal-text {
  background: #FFFAEF;
  height: 40px;
}
</style>
